import React, { useState } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Drawer, Typography } from '@material-ui/core'
import ThemeSettings from './theme-settings'
import { useSelector, useDispatch } from 'react-redux'
import { themeDrawerOpen } from 'src/reducers/course/action'
import { CoreButton, CoreIconButton } from '../core'
import { Icon } from '@iconify/react'
const ThemeSettingsDrawer = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const themeDrawerState = useSelector(state => state.course.themeDrawerOpen)

  const drawerOpenController = () => {
    dispatch(themeDrawerOpen())
  }
  const [page, setPage] = useState('preset-settings') // settings, preset-settings

  return (
    <div>
      <Drawer
        variant="temporary"
        anchor="right"
        classes={{ paper: classes.drawer }}
        open={themeDrawerState}
        onClose={() => drawerOpenController()}
        onOpen={() => drawerOpenController()}
        transitionDuration={{ enter: 700, exit: 700 }}
      >
        <div className={classes.list}>
          {page === 'preset-settings' ? (
            <Typography className={classes.tabList}>
              Course Theme Settings
            </Typography>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: '36px',
                marginBottom: '20px',
                position: 'relative',
                justifyContent: 'center',
              }}
            >
              <CoreIconButton
                onClick={() => setPage('preset-settings')}
                variant="text"
                color="secondary"
                size="small"
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                }}
              >
                <Icon icon="ic-round-chevron-left" fontSize="24px"></Icon>
              </CoreIconButton>
              <Typography fontSize="16px" fontFamily="Inter" fontWeight={500}>
                Discover Presets
              </Typography>
            </div>
          )}
          <ThemeSettings page={page} setPage={setPage} />
        </div>
      </Drawer>
    </div>
  )
}
export default withStyles(styles)(ThemeSettingsDrawer)
